"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formatted = _interopRequireDefault(require("./formatted"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * This component formats input as a PhoneNumber
 */
var PhoneNumberTextField = function PhoneNumberTextField(props) {
  return /*#__PURE__*/_react.default.createElement(_formatted.default, _extends({}, props, {
    formatValue: _formatValue
  }));
};

function _formatValue(value) {
  var numbers = "";

  if (value) {
    numbers = value.replace(/[^0-9]+/g, "");
  }

  var formatted = numbers;

  if (numbers.length > 6) {
    formatted = "(".concat(numbers.substring(0, 3), ") ").concat(numbers.substring(3, 6), "-").concat(numbers.substring(6, 10));
  } else if (numbers.length > 3) {
    formatted = "(".concat(numbers.substring(0, 3), ") ").concat(numbers.substring(3, 6));
  } else if (numbers.length > 0) {
    formatted = "(".concat(numbers.substring(0, 3));
  }

  return {
    formatted: formatted,
    raw: numbers.substring(0, 10)
  };
}

var _default = PhoneNumberTextField;
exports.default = _default;